import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { PrimaryHeading } from '../../atoms/PrimaryHeading'
import { ICompanyBase } from '../../../types'
import { AngelCard } from '../../molecules/AngelCard'
import { VCCard } from '../../molecules/VCCard'
import { getUniqueReceivedInvestments } from '../../../utils'
import { NoContent } from '../../atoms/NoContent'

type Props = {
  company: ICompanyBase
}

export const CompanyProfileFinance: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['companies-[id]'])
  // VC の場合は receivedInvestments が登録されていれば表示
  if (company?.isVc) {
    return (
      company?.receivedInvestments.length > 0 && (
        <div className={styles.container}>
          <div className={styles.heading}>
            <PrimaryHeading backgroundText='INVESTORS' htmlTagType='h2'>
              {t('投資家')}
            </PrimaryHeading>
          </div>
          <div className={styles.content}>
            <div className={styles.cardList}>
              {getUniqueReceivedInvestments(company.receivedInvestments).map((receivedInvestment) => {
                return (
                  <div key={receivedInvestment.id} className={styles.cardItem}>
                    {receivedInvestment.angel ? (
                      <AngelCard item={receivedInvestment.angel} shouldDisplayInvestorType />
                    ) : (
                      <VCCard item={receivedInvestment.companyInvestedFrom} shouldDisplayInvestorType />
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )
    )
  }

  // スタートアップの場合は常に表示
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='INVESTORS' htmlTagType='h2'>
          {t('投資家')}
        </PrimaryHeading>
      </div>
      <div className={styles.content}>
        {company?.receivedInvestments.length === 0 ? (
          <NoContent>{t('投資家がまだ登録されていません。')}</NoContent>
        ) : (
          <div className={styles.cardList}>
            {getUniqueReceivedInvestments(company.receivedInvestments).map((receivedInvestment) => {
              return (
                <div key={receivedInvestment.id} className={styles.cardItem}>
                  {receivedInvestment.angel ? (
                    <AngelCard item={receivedInvestment.angel} shouldDisplayInvestorType />
                  ) : (
                    <VCCard item={receivedInvestment.companyInvestedFrom} shouldDisplayInvestorType />
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
